import React, { Component } from 'react';
import { connect } from 'react-redux';
import { matchPath } from 'react-router-dom';

import * as actions from '../../services/student/actions';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

import './WebInterface.scss';

import getQueryParams from '../../utils/getQueryParams.js';

export class WebInterface extends Component {
    redirectToLandingPage() {
        const { history, location } = this.props;
        const match = matchPath(location.pathname, {
            path: '/:device/:schoolId/:page',
            exact: true,
            strict: false
        });
        const { device, schoolId } = match.params;
        const zoomLevel = getQueryParams(location.search)['zoom'] || 1;

        if (device !== 'kiosk')
            history.push(`/${device}/${schoolId}?zoom=${zoomLevel}`);
        else
            window.location = `http://www.folio.com.hk/ranking&code=${schoolId}&zoom=${zoomLevel}`;
    }

    redirectToLoginPage() {
        const { history, location } = this.props;
        let match = matchPath(location.pathname, {
            path: '/:device/:schoolId',
            strict: false
        });
        const { device, schoolId } = match.params;
        const zoomLevel = getQueryParams(location.search)['zoom'] || 1;

        history.push(`/${device}/${schoolId}/helper-login?zoom=${zoomLevel}`);
    }

    handleLogout(e) {
        const { history, location, updateStudentUserInfo } = this.props;
        const match = matchPath(location.pathname, {
            path: '/:device/:schoolId',
            strict: false
        });
        const { device, schoolId } = match.params;
        const zoomLevel = getQueryParams(location.search)['zoom'] || 1;

        updateStudentUserInfo({ class: '', isGaming: false, isHelper: false });
        history.push(`/${device}/${schoolId}?zoom=${zoomLevel}`);
    }

    render() {
        const { location, children, selectedClass, isGaming } = this.props;
        const match = matchPath(location.pathname, {
            path: '/:device/:schoolId/:page',
            exact: true,
            strict: false
        }) || { params: {} };
        const { device } = match.params;
        const zoomLevel = getQueryParams(location.search)['zoom'] || 1;
        const isLoginPage = match && (match.params.page === 'login' || match.params.page === 'helper-login')

        return (
            <div 
                className="WebInterface"
                style={{ 'zoom': zoomLevel < 0.8 ? 0.8 : zoomLevel }}
            >
                <Header 
                    isKiosk={device === 'kiosk'}
                    isMultiLingual={true}
                    isLoginBtnAvailable={!isGaming}
                    isBackBtnAvailable={isLoginPage}
                    selectedClass={selectedClass} 
                    onLoginBtnClick={(e) => this.redirectToLoginPage()}
                    onLogoutBtnClick={(e) => this.handleLogout(e)}
                    onBackBtnClick={(e) => this.redirectToLandingPage()}
                />
                <div className="container">
                    {children}
                </div>
                <Footer
                    isKiosk={device === 'kiosk'}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    selectedClass: state.student.class,
    isGaming: state.student.isGaming,
    isHelper: state.student.isHelper
})

export default connect(mapStateToProps, actions)(WebInterface);